import { Button } from '@/shared/ui/Button';
import { cn } from '@/shared/utils/cn';

type SubmitButtonProps = {
  loading?: boolean;
  label?: string;
  loadingLabel?: string;
  disabled?: boolean;
  className?: string;
};

export function SubmitButton({
  loading = false,
  label = 'Enviar',
  loadingLabel = 'Enviando...',
  disabled,
  className,
}: SubmitButtonProps) {
  return (
    <Button
      type="submit"
      variant="primary"
      size="lg"
      loading={loading}
      disabled={disabled}
      className={cn('w-full', className)}
    >
      {loading ? loadingLabel : label}
    </Button>
  );
}
